import React from 'react';
import TransitionLink from 'components/transition-link/transition-link';
import classNames from 'classnames';
import MakeHash from 'make-hash';
import routes from 'routes/routes';
import Text from 'components/text/text';

class NavLinks extends React.Component {
  constructor(props) {
    super(props);

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onNavLinkClick = this.handleNavLinkClick.bind(this);
  }

  handleNavLinkClick(event) {
    if (this.props.onNavLinkClick) {
      this.props.onNavLinkClick();
    }
  }

  render() {
    const navClasses = classNames(
      'navList',
      {
        'navList_hidden': !this.props.isVisible
      }
    );

    return (
      <ul className={navClasses}>
        {routes.nav.map((route, i) => {
          return (
            <li key={MakeHash(`${route.path}-${i}`)}>
              <TransitionLink
                className="navLink"
                activeClassName="navLink_active"
                to={route.path}
                onClick={this.onNavLinkClick}
              >
                {route.localizedName()}
              </TransitionLink>
            </li>
          )
        })}
      </ul>
    );
  }
}

export default NavLinks;



// WEBPACK FOOTER //
// ./src/client/components/nav/nav-links.jsx